import { useTranslation } from "react-i18next";
import Accordion from "../components/Accordion";
import Icon from "../components/Icon";
import Reveal from "../components/Reveal";
import SectionHead from "../components/SectionHead";
import { FAQS } from "../data/trust";
import { SITE } from "../data/site";
import { useL } from "../lib/useLang";
import { scrollToSection } from "../lib/navigation";

export default function Faq() {
  const { t } = useTranslation();
  const L = useL();

  const items = FAQS.map((faq) => ({
    id: faq.id,
    question: L(faq.q),
    answer: L(faq.a),
  }));

  return (
    <section className="fsg-section fsg-faq-section" id="faq">
      <div className="fsg-container">
        <div className="fsg-split fsg-split--sticky">
          <div className="fsg-sticky-rail">
            <SectionHead
              eyebrow={t("faq.eyebrow")}
              title={t("faq.title")}
              lead={t("faq.lead")}
            />

            <Reveal className="fsg-card">
              <h3 style={{ fontSize: "var(--fsg-fs-h4)" }}>{t("faq.more")}</h3>
              <div
                className="fsg-btn-row"
                style={{ marginTop: "var(--fsg-s-3)" }}
              >
                <button
                  type="button"
                  className="fsg-btn fsg-btn--primary fsg-btn--sm"
                  onClick={() => scrollToSection("contacto")}
                >
                  {t("cta.askUs")}
                </button>
                <a
                  className="fsg-btn fsg-btn--ghost fsg-btn--sm"
                  href={`https://wa.me/${SITE.whatsapp}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <Icon name="whatsapp" />
                  WhatsApp
                </a>
              </div>
            </Reveal>
          </div>

          <Reveal>
            <Accordion items={items} />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
